import config from 'config';
import { accrualsFormats } from 'src/helpers/formatting';
import { hasValue } from 'swipeclock-frontend';

export const finalizeTransformer = (payPeriods, jwt) => {
  const { periods } = payPeriods;

  const transformedPayPeriods = periods.map((period) => {
    if (hasValue(period.warnings)) {
      const { warnings: errors, beginDate } = period;
      const start = accrualsFormats.formatDateForPayrollReview(beginDate);
      const {
        empApprovalsNeeded,
        employeesMissingApprovals,
        manApprovalsNeeded,
        missedPunches,
        pendingRequests,
        supApprovalsNeeded,
        unmatchedPunches,
      } = errors;

      /* eslint-disable */
      const tor = `${config.embeddedTimeUIURL}/timeoff.html?jwt=${jwt}#/requests/pending?hide=mytimeoff`;
      const timecard = `${config.embeddedTimeUIURL}/timecard.html?jwt=${jwt}#/manage?hide=export&hide=topbar&date=${start}`;
      const punches = `${config.embeddedTimeUIURL}/timecard.html?jwt=${jwt}#/manage?hide=export&hide=topbar&filter=punches&date=${start}`;
      /* eslint-enable */

      const warningFormats = [
        {
          warning: empApprovalsNeeded,
          message:
            empApprovalsNeeded > 1
              ? 'Employee Approvals Needed'
              : 'Employee Approval Needed',
          linkText: 'Click to view employee approvals',
          url: timecard,
        },
        {
          warning: employeesMissingApprovals,
          message:
            employeesMissingApprovals > 1
              ? 'Employees Missing Approvals'
              : 'Employee Missing Approval',
          linkText: 'Click to view employee approvals',
          url: timecard,
        },
        {
          warning: manApprovalsNeeded,
          message:
            manApprovalsNeeded > 1
              ? 'Manager Approvals Needed'
              : 'Manager Approval Needed',
          linkText: 'Click to view manager approvals',
          url: timecard,
        },
        {
          warning: missedPunches,
          message: missedPunches > 1 ? 'Missing Punches' : 'Missing Punch',
          linkText: 'Click to view missing punches',
          url: punches,
        },

        {
          warning: pendingRequests,
          message:
            pendingRequests > 1 ? 'Time Off Requests' : 'Time Off Request',
          linkText: 'Click to view time off requests',
          url: tor,
        },
        {
          warning: supApprovalsNeeded,
          message:
            supApprovalsNeeded > 1
              ? 'Supervisor Approvals Needed'
              : 'Supervisor Approval Needed',
          linkText: 'Click to view supervisor approvals',
          url: timecard,
        },
        {
          warning: unmatchedPunches,
          message:
            unmatchedPunches > 1 ? 'Unmatched Punches' : 'Unmatched Punch',
          linkText: 'Click to view unmatched punches',
          url: punches,
        },
      ];

      const warnings = warningFormats.filter(
        (warningFormat) => warningFormat.warning >= 1
      );

      return { ...period, warnings };
    }

    return { ...period, warnings: [] };
  });

  return transformedPayPeriods.reverse();
};
